<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div v-if="attribute" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" @click="close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">
						Formula
						<template v-if="attribute">
							{{ attribute.name }}
						</template>
					</h4>
				</div>
				<div v-if="attribute.formula" class="modal-body">
					<div class="row">
						<div v-if="operations" class="col-md-12">
							<select v-if="operations.length" v-model="attribute.formula.product_operation_id" class="form-control">
								<option v-for="operation in operations" :value="operation.id">
									{{ operation.name }}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div v-if="attribute.formula" class="modal-footer">
					<button @click="update()" ref="btnUpdate" type="button" class="btn btn-success">Actualizar</button>
					<button @click="destroy()" ref="btnDestroy" type="button" class="btn btn-danger">Eliminar</button>
					<button type="button" class="btn btn-default" @click="close">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-attribute-formula-' + Math.floor(Math.random() * 736456),
				},

				attribute: null,
				originalAttribute: null,
				operations: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getOperations()
			},
			open(attribute) {
				this.originalAttribute = attribute
				this.attribute = JSON.parse(JSON.stringify(attribute))

				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getOperations () {
				this.$http.get('admin/management/products/operation')
					.then(response => {
						this.operations = response.body
					})
			},
			operate() {
				if(this.attribute) {
					var val = null
					if(this.attribute.product_attribute_type_field_id == 1) {
						val = this.attribute.value.decimal_value
					}

					if(this.attribute.product_attribute_type_field_id == 2) {
						val = this.attribute.value.integer_value
					}

					if(val) {
						var result = null
						if(this.attribute.formula.product_operation_id == 1) {
							result = parseFloat(val) + parseFloat(this.attribute.formula.value)
						}
						if(this.attribute.formula.product_operation_id == 2) {
							result = parseFloat(val) * parseFloat(this.attribute.formula.value)
						}
						if(result) {
							this.attribute.formula.total = parseFloat(result).toFixed(2)
						}
					}
				}
			},
			update() {
				this.operate()
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()
				this.$http.put('admin/management/products/attribute/storage/formula/' + this.attribute.formula.id, this.attribute.formula)
				.then(response => {
					var formula = response.body.data
					this.originalAttribute.formula = formula
					this.$emit('attributeFormulaUpdated', this.originalAttribute.formula)
					this.close()
					loading.stop()
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
			destroy() {
				var loading = Ladda.create(this.$refs.btnDestroy)
				loading.start()
				this.$http.delete('admin/management/products/attribute/storage/formula/' + this.attribute.formula.id)
				.then(response => {
					this.originalAttribute.formula = null
					this.$emit('attributeFormulaUpdated')
					this.close()
					loading.stop()
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/views/AttributeFormula.vue